import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { evaluationAtom } from "@_recoil/_state";
import { swalError } from "@unisearch/helpers";
import { getIntakes } from "@unisearch/helpers";

import styles from "./evaluation_intake.module.scss";

const EvaluationIntake = () => {
  const intakes = getIntakes();
  const YEAR = new Date().getFullYear();

  const [{ courseIntake }, setCountryIntake] = useRecoilState(evaluationAtom);

  const handleIntake = (event, year, data) => {
    const { checked } = event.target;

    //when unchecked remove form selected
    if (!checked) {
      setCountryIntake((prev) => ({
        ...prev,
        courseIntake: courseIntake.filter((item) => {
          if (item.year == year) {
            return Object.values(item.data)[0] != Object.values(data)[0];
          } else {
            return true;
          }
        }),
      }));
      return false;
    }

    //checked store max 2 Intake
    if (courseIntake.length >= 2) {
      swalError("You can select max 2 Intake");
      return false;
    }

    if (checked) {
      let obj = { year, data };
      setCountryIntake((prev) => ({
        ...prev,
        courseIntake: [...prev.courseIntake, obj],
      }));
    }
  };

  const isChecked = (year, data) => {
    let selectedItem = courseIntake.filter((item) => {
      if (item.year == year) {
        return Object.values(item.data)[0] == Object.values(data)[0];
      } else {
        return false;
      }
    });
    return selectedItem.length ? true : false;
  };

  useEffect(() => {
    if (courseIntake.length) {
      setCountryIntake((prev) => ({
        ...prev,
        show_next: true,
      }));
    }
  }, [courseIntake]);

  return (
    <>
      <div className={styles.title_wrapper}>
        <div className={styles.title}>
          When Would You Like to Start Your Program?
        </div>
      </div>
      <div className={styles.content}>
        <ul>
          <li>
            <div className={styles.name}>{YEAR}</div>
            <div className={styles.timeline_wrapper}>
              {intakes &&
                intakes[YEAR].map((item, key) => {
                  return (
                    <label
                      key={`${YEAR}_${key}`}
                      className={`${styles.timeline} ${
                        isChecked(YEAR, item) ? styles.active : ""
                      } `}
                    >
                      <input
                        type="checkbox"
                        name="intake[]"
                        onChange={(e) => handleIntake(e, YEAR, item)}
                        checked={isChecked(YEAR, item)}
                        style={{ display: "none" }}
                      />
                      {Object.values(item)[0]
                        ? Object.values(item)[0].substring(0, 3)
                        : ""}
                      {" - "}
                      {Object.values(item)[2]
                        ? Object.values(item)[2].substring(0, 3)
                        : ""}
                    </label>
                  );
                })}
            </div>
          </li>
          <li>
            <div className={styles.name}>{YEAR + 1}</div>
            <div className={styles.timeline_wrapper}>
              {intakes &&
                intakes[YEAR + 1] &&
                intakes[YEAR + 1].map((item, key) => {
                  return (
                    <label
                      key={`${YEAR}_${key}`}
                      className={`${styles.timeline} ${
                        isChecked(YEAR + 1, item) ? styles.active : ""
                      } `}
                    >
                      <input
                        type="checkbox"
                        name="intake[]"
                        onChange={(e) => handleIntake(e, YEAR + 1, item)}
                        checked={isChecked(YEAR + 1, item)}
                        style={{ display: "none" }}
                      />
                      {Object.values(item)[0]
                        ? Object.values(item)[0].substring(0, 3)
                        : ""}
                      {" - "}
                      {Object.values(item)[2]
                        ? Object.values(item)[2].substring(0, 3)
                        : ""}
                    </label>
                  );
                })}
            </div>
          </li>
          <li>
            <div className={styles.name}>{YEAR + 2}</div>
            <div className={styles.timeline_wrapper}>
              {intakes &&
                intakes[YEAR + 1] &&
                intakes[YEAR + 1].map((item, key) => {
                  return (
                    <label
                      key={`${YEAR}_${key}`}
                      className={`${styles.timeline} ${
                        isChecked(YEAR + 2, item) ? styles.active : ""
                      } `}
                    >
                      <input
                        type="checkbox"
                        name="intake[]"
                        value={item}
                        onChange={(e) => handleIntake(e, YEAR + 2, item)}
                        checked={isChecked(YEAR + 2, item)}
                        style={{ display: "none" }}
                      />
                      {Object.values(item)[0]
                        ? Object.values(item)[0].substring(0, 3)
                        : ""}
                      {" - "}
                      {Object.values(item)[2]
                        ? Object.values(item)[2].substring(0, 3)
                        : ""}
                    </label>
                  );
                })}
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default EvaluationIntake;
